import React, {
  ReactNode,
  createContext,
  Dispatch,
  SetStateAction,
} from "react";
import useSettings, { AutoSignPayload } from "./hooks/useSettings";

interface SettingsContextProviderProps {
  children: ReactNode;
}

interface SettingsContextData {
  messageTitle: string;
  updateMessageTitle: (
    newTitle: string,
    emailBody?: string,
    autoSign?: AutoSignPayload
  ) => any;
  setMessageTitle: Dispatch<SetStateAction<string>>;
  getMessageTitleByUserId: (UserId: string) => any;
  messageEmailBody: string;
  setMessageEmailBody: Dispatch<SetStateAction<string>>;
  autoSignEnabled: boolean;
  setAutoSignEnabled: Dispatch<SetStateAction<boolean>>;
  hasStoredSignature: boolean;
  hasStoredDocument: boolean;
}

const initialState: SettingsContextData = {
  messageTitle: "",
  updateMessageTitle: () => {},
  setMessageTitle: () => {},
  getMessageTitleByUserId: () => {},
  messageEmailBody: "",
  setMessageEmailBody: () => {},
  autoSignEnabled: false,
  setAutoSignEnabled: () => {},
  hasStoredSignature: false,
  hasStoredDocument: false,
};

export const SettingsContext = createContext<SettingsContextData>(initialState);

export default function SettingsContextProvider({
  children,
}: SettingsContextProviderProps) {
  const {
    messageTitle,
    updateMessageTitle,
    setMessageTitle,
    getMessageTitleByUserId,
    messageEmailBody,
    setMessageEmailBody,
    autoSignEnabled,
    setAutoSignEnabled,
    hasStoredSignature,
    hasStoredDocument,
  } = useSettings();

  return (
    <SettingsContext.Provider
      value={{
        messageTitle,
        updateMessageTitle,
        setMessageTitle,
        getMessageTitleByUserId,
        messageEmailBody,
        setMessageEmailBody,
        autoSignEnabled,
        setAutoSignEnabled,
        hasStoredSignature,
        hasStoredDocument,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}
